import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import { OrderedSet } from 'immutable';
import classNames from 'classnames';

import QTip from 'components/QuickenControls/QTip';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles/index';
import RefreshIcon from '@material-ui/icons/RefreshRounded';
import SyncProblemIcon from '@material-ui/icons/SyncProblem';

import {appRefreshAll as refreshAllAction, setAppProps} from 'data/app/actions';
import * as selectors from 'data/app/selectors';
import { getDatasetId } from 'utils/auth/selectors';
import { hardReset } from 'data/actions';

const styles = (theme) => ({
  buttonRoot: {
    outline: 'none !important',
    fontSize: 'unset',
  },
  refreshButtonDisabled: {
    opacity: 0.6,
  },
  disabledIcon: {
    opacity: 0.75,
  },
  refreshDivButton: {
  },
  navText: {
    color: theme.components.navigation.textColor,
  },
  disabledRefreshDivButton: {
    pointerEvents: 'none',
  },
});

const RefreshButton = (props) => {
  const {
    classes, disableRefreshButton, isRefreshing, refreshAll, datasetId,
    dispatchSetAppPropsAction, updateAllFailed, size, theme, isInAccountBar, updateAllMessages, dispatchHardResetAction,
  } = props;

  const refreshAction = (e) => {
    e.stopPropagation();
    if (e.shiftKey && e.altKey && e.metaKey) { // hard refresh - purge persist
      dispatchHardResetAction();
    }
    dispatchSetAppPropsAction({
      updateAllFailed: undefined,
      updateAllMessages: new OrderedSet([]),
    });
    refreshAll();
  };

  // Main icon button that acme and quicken use
  const refreshIconRoot =
    <IconButton
      tabIndex={isInAccountBar ? -1 : 0}
      aria-label="Refresh All"
      disabled={disableRefreshButton}
      classes={{
        root: classes.buttonRoot,
        disabled: classes.refreshButtonDisabled,
      }}
      style={{ color: !isInAccountBar && theme.components.navigation.iconColor, padding: !isInAccountBar && 0 }}
      onClick={refreshAction}
    >
      {updateAllFailed ? <SyncProblemIcon style={{fontSize: size}}/> : <RefreshIcon style={{fontSize: size}}/>}
    </IconButton>;


  if (!datasetId) {
    return null;
  }

  return (
    isInAccountBar ?
      <>
        {isRefreshing &&
        <IconButton
          aria-label="Refresh All Busy"
          disabled
          classes={{root: classes.buttonRoot}}
        >
          <CircularProgress
            size={size || 22}
            style={{color: theme.components.navigation.iconColor}}
          />
        </IconButton>
        }
        {!isRefreshing &&
        <QTip
          html={updateAllMessages && updateAllMessages.size ?
            updateAllMessages.map((message) => <div key={message}>{message}</div>) :
            <div>Update All</div>}
          placement="right"
        >
          {refreshIconRoot}
        </QTip>
        }
      </> :
      <div
        role="button"
        tabIndex={0}
        onClick={refreshAction}
        onKeyPress={refreshAction}
        className={classNames(classes.refreshDivButton, disableRefreshButton && classes.disabledRefreshDivButton)}
      >
        {isRefreshing ?
          <IconButton
            aria-label="Refresh All Busy"
            disabled
            classes={{root: classes.buttonRoot}}
            style={{ padding: 0 }}
          >
            <CircularProgress
              size={size || 22}
              style={{color: theme.components.navigation.iconColor}}
            />
          </IconButton>
          :
          refreshIconRoot}
        <Typography style={{marginLeft: 24, textAlign: 'left'}} className={classes.navText}>
          Refresh
        </Typography>
      </div>
  );
};

RefreshButton.propTypes = {
  disableRefreshButton: PropTypes.bool,
  isRefreshing: PropTypes.bool,
  updateAllFailed: PropTypes.bool,
  refreshAll: PropTypes.func,
  dispatchSetAppPropsAction: PropTypes.func,
  dispatchHardResetAction: PropTypes.func,
  classes: PropTypes.object,
  theme: PropTypes.object,
  updateAllMessages: PropTypes.object,
  size: PropTypes.number,
  datasetId: PropTypes.string,
  isInAccountBar: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  disableRefreshButton: selectors.disableRefreshButton(state),
  isRefreshing: selectors.isRefreshing(state),
  updateAllFailed: selectors.getUpdateAllFailed(state),
  updateAllMessages: selectors.getUpdateAllMessages(state),
  datasetId: getDatasetId(state),
});

const mapDispatchToProps = (dispatch) => ({
  refreshAll: () => dispatch(refreshAllAction(undefined, {context: 'refreshAll'})),
  dispatchSetAppPropsAction: (data) => dispatch(setAppProps(data)),
  dispatchHardResetAction: () => dispatch(hardReset()),
});

export default compose(
  withStyles(styles, {name: 'RefreshAllButton', withTheme: true}),
  connect(mapStateToProps, mapDispatchToProps)
)(RefreshButton);
